import React from 'react';
import { useTranslation } from 'react-i18next';
import { FiLink, FiSmartphone, FiMessageSquare, FiMonitor, FiVideo, FiUserPlus } from 'react-icons/fi';
import './Features.css';

function Features() {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: <FiLink />,
      titleKey: 'features.connection.title',
      descriptionKey: 'features.connection.description'
    },
    {
      icon: <FiSmartphone />,
      titleKey: 'features.zeroInstall.title',
      descriptionKey: 'features.zeroInstall.description'
    },
    {
      icon: <FiMonitor />,
      titleKey: 'features.multiShare.title',
      descriptionKey: 'features.multiShare.description'
    },
    {
      icon: <FiMessageSquare />,
      titleKey: 'features.chat.title',
      descriptionKey: 'features.chat.description'
    },
    {
      icon: <FiVideo />,
      titleKey: 'features.quality.title',
      descriptionKey: 'features.quality.description'
    },
    {
      icon: <FiUserPlus />,
      titleKey: 'features.guests.title',
      descriptionKey: 'features.guests.description'
    }
  ];

  return (
    <section id="fonctionnalites" className="features section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{t('features.title')}</h2>
          <p className="section-quick-answer">{t('features.quickAnswer')}</p>
          <p className="section-subtitle">
            {t('features.subtitle')}
          </p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                {feature.icon}
              </div>
              <h3 className="feature-title">{t(feature.titleKey)}</h3>
              <p className="feature-description">{t(feature.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;

